{
  "slogan": "人人可用的数据平台",
  "title": "登录",
  "appleLogin": {
    "title": "使用 Apple 登录"
  },
  "wxLogin": {
    "title": "使用微信登录"
  },
  "mobileLogin": {
    "title": "使用手机登录",
    "mobilePlaceholder": "手机号",
    "codePlaceholder": "验证码",
    "tryAgainLater": "请稍后再试",
    "geetestFailed": "验证失败",
    "geetestFailedMessage": "验证码加载失败，请稍后重试",
    "sendCode": "发送验证码",
    "sendCodeFailed": "验证码发送失败",
    "sendCodeSuccess": "验证码发送成功",
    "codeVerificationFailed": "验证失败，请重试"
  },
  "completeRegistration": {
    "tips": "根据相关法律法规，用户必须绑定手机号之后，才允许发布表单。",
    "sendCodeFailed": "验证码发送失败，请稍后再试",
    "codeVerificationFailed": "验证码错误，请重试",
    "registerOrBindFailed": "出现错误，请稍后再试",
    "mobilePlaceholder": "手机号",
    "codePlaceholder": "验证码",
    "sendCode": "发送验证码",
    "bindMobileNo": "绑定手机号"
  },
  "identityLogin": {
    "title": "使用密码登录",
    "identityPlaceholder": "手机号或邮箱",
    "passwordPlaceholder": "密码",
    "identityOrPasswordIncorrect": "手机号或邮箱，密码不正确"
  },
  "agreement": "我已阅读并同意 <terms>使用条款</terms>、<privacy>隐私政策</privacy>",
  "signUpOrLogin": "注册/登录",
  "login": "登录",
  "loginFailed": "登录失败"
}
